"use client";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import React from "react";


function makeQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        // 데이터 캐싱 활용 (30초 동안 fresh 상태 유지)
        staleTime: 30 * 1000, // 30초
        // 컴포넌트 마운트 시 refetch (React Query v5)
        refetchOnMount: true,
        // 윈도우 포커스 시 refetch 비활성화 (성능 개선)
        refetchOnWindowFocus: false,
        // 자동 재시도 최소화
        retry: 1,
        // 캐시 시간 (5분)
        gcTime: 5 * 60 * 1000,
      },
      mutations: {
        retry: false,
      },
    },
  })
}

let browserQueryClient: QueryClient | undefined = undefined

function getQueryClient() {
  if (typeof window === 'undefined') {
    // Server일 경우
    // 매번 새로운 queryClient를 만든다.
    return makeQueryClient()
  } else {
    // Browser일 경우
    // queryClient가 존재하지 않을 경우에만 새로운 queryClient를 만든다.
    // React가 새 Client를 만들게 하기 위해 중요하다.
    if (!browserQueryClient) browserQueryClient = makeQueryClient()
    return browserQueryClient
  }
}

const ReactQueryProvider = ({ children }: { children: React.ReactNode }) => {
  // const [queryClient] = useState(
  //   () =>
  //     new QueryClient({
  //       defaultOptions: {
  //         queries: {
  //           refetchOnWindowFocus: true,
  //           retry: 1,
  //           staleTime: 0,
  //         },
  //         mutations: {
  //           retry: false,
  //         },
  //       },
  //     })
  // );

  const queryClient = getQueryClient()

  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
};

export default ReactQueryProvider;
